import React, { useState } from "react";
import Alternative from "./Alternative";
import Expensive from "./Expensive";
import Technical from "./Technical";
import SetupUse from "./SetupUse";
import Others from "./Others";
import HttpClient from "../../../../../actions/http-client";
import { CANCEL_PLAN_SUBSCRIPTION, PLAN_DISCOUNT } from "../../../../../actions/api";
import { toast } from "react-toastify";
import { GET_PROD_SUBSCRIPTION } from "../../../../../actions/accountsActions";
import { useDispatch } from "react-redux";


const CancelSubComponents = (props) => {
    const { pageData, handleStatusChange, updateCancellationType, acceptOfferSub } = props;
    const { planId, product_id } = props.planDetails;
    const [alternativeValue, setAlternativeValue] = useState({ feedbackName: '', feedbackContent: '', otherValue: '' });
    const [otherValue, setOtherValue] = useState({ feedbackContent: '' });
    const [technicalValue, setTechnicalValue] = useState({ feedbackOption: '', feedbackContent: '' });
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [offerRequest, setOfferRequest] = useState(false);
    const dispatch = useDispatch();

    const cancelSubscription = () => {
        if (pageData.type == 1) {
            const { feedbackName, feedbackContent, otherValue } = alternativeValue;
            if (feedbackName.length == 0 || feedbackContent.length == 0) {
                setError(true);
                return;
            }else if(feedbackName == 'Prefer something else? Let us know your enchanting choice below!' && otherValue.length == 0){
                setError(true);
                return;
            }
        } else if (pageData.type == 3) {
            const { feedbackOption, feedbackContent } = technicalValue;
            if (feedbackOption == 'Anything else.' && feedbackContent.length == 0) {
                setError(true);
                return;
            } else if (feedbackOption == '') {
                setError(true);
                return;
            }
        } else if (pageData.type == 5) {
            const { feedbackContent } = otherValue;
            if (feedbackContent.length == 0) {
                setError(true);
                return;
            }
        }
        cancelApi();
    }

    const cancelApi = () => {
        setLoading(true);
        setError(false);
        const obj = {
            planId: planId,
            productId: product_id,
            type: pageData.type,
            name: pageData.interHeading,
            feedbackName: '',
            feedbackContent: '',
            feedbackOption: '',
            adminId: localStorage.getItem('Isadmin') ?? localStorage.getItem('ownerId'),
        }

        if (pageData.type == 1) {
            const { feedbackName, feedbackContent, otherValue } = alternativeValue;
            let feedName = feedbackName;
            if(feedbackName == 'Prefer something else? Let us know your enchanting choice below!'){
                feedName = otherValue;
            }
            obj['feedbackName'] = feedName;
            obj['feedbackContent'] = feedbackContent;
        } else if (pageData.type == 3) {
            const { feedbackOption, feedbackContent } = technicalValue;
            obj['feedbackOption'] = feedbackOption;
            obj['feedbackContent'] = feedbackContent;
        } else if (pageData.type == 5) {
            const { feedbackContent } = otherValue;
            obj['feedbackContent'] = feedbackContent;
        }
        
        new HttpClient().post(CANCEL_PLAN_SUBSCRIPTION, obj).then(res => {
            setLoading(false);
            if (res && Object.keys(res).length > 0) {
                const { responseMessage } = res.data;
                if (res.status == 200) {
                    toast.success(responseMessage, { autoClose: 3000 });
                    dispatch(GET_PROD_SUBSCRIPTION());
                    if (pageData.type == 1 || pageData.type == 3 || pageData.type == 5) {
                        updateCancellationType(1);
                    } else {
                        updateCancellationType(2);
                    }
                } else {
                    toast.error(responseMessage, { autoClose: 3000 });
                }
            }
        }).catch(ex => {
            if (ex && Object.keys(ex).length > 0) {
                const { data } = Object.keys(ex).length > 0 ? ex.response : {};
                const { responseMessage} = data;
                const msg = (typeof responseMessage) == 'object' ? "Subscription not found" : responseMessage;
                if (data && Object.keys(data).length > 0) {
                    toast.error(msg, { autoClose: 3000 });
                } else toast.error('Something went worng!', { autoClose: 3000 });

            }
            setLoading(false);

        })
    }

    const acceptOfferSubscription = () => {
        setOfferRequest(true);
        new HttpClient().post(PLAN_DISCOUNT, {
            planId: planId,
            productId: product_id,
        }).then(res => {
            if (Object.keys(res).length > 0) {
                const { responseMessage, responseCode, responsvalue } = res.data;
                setOfferRequest(false);
                if (responseCode == 200) {
                    toast.success(responseMessage, { autoClose: 3000 });
                    acceptOfferSub(responsvalue);
                    updateCancellationType(3);
                }
                else {
                    toast.error(responseMessage, { autoClose: 3000 });
                }
            }
        }).catch(ex => {
            if (ex && Object.keys(ex).length > 0) {
                const { data } = Object.keys(ex).length > 0 ? ex.response : {};
                const { responseMessage} = data;
                const msg = (typeof responseMessage) == 'object' ? "Subscription not found" : responseMessage;
                if (data && Object.keys(data).length > 0) {
                    toast.error(msg, { autoClose: 3000 });
                } else toast.error('Something went worng!', { autoClose: 3000 });
            }
            setOfferRequest(false);

        })
    }

    return (
        <div className="justify-content-center align-items-center">
            <div className="small_container">
                <h3 className="font-weight-bolder text-dark network_title_wt mb-5">{pageData.heading}</h3>
                <div className="card d-flex py-5 px-8 mb-5">
                    <div className="card-inner d-flex flex-wrap align-items-center">
                        <div className="card-icon">{pageData.icon}</div>
                        <div className="card-details">
                            <h5 className="font-weight-bolder text-dark network_title_wt mb-2">{pageData.interHeading}</h5>
                            <p className="mb-0">{pageData.text}</p>
                        </div>
                    </div>
                </div>

                <div className="cancellation-box">
                    {pageData.type == 1 && <Alternative {...{ alternativeValue, setAlternativeValue, error, setError }} />}
                    {pageData.type == 2 && <Expensive {...{ acceptOfferSubscription, offerRequest }} />}
                    {pageData.type == 3 && <Technical {...{ setTechnicalValue, technicalValue, error, setError }} />}
                    {pageData.type == 4 && <SetupUse />}
                    {pageData.type == 5 && <Others {...{ setOtherValue, error, setError }} />}
                </div>
            </div>
            <div className="cancellation-footer position-absolute w-100 bottom-0 left-0 py-5 bg-white">
                <div className="small_container">
                    <div className="text-right">
                        <button className="btn btn-secondary" onClick={() => handleStatusChange({}, 0)}>I've changed my mind, Go Back</button>
                        <button className={`btn btn-primary ${loading ? 'spinner spinner-right disabled' : ''} ms-2`} onClick={() => cancelSubscription()}>Continue to cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CancelSubComponents;